import _ from "lodash";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import appHistory from "../app/appHistory";
import useIsFirstRender from "./useIsFirstRender";

export const useInitialUrlSearchParams = (searchParamsList, hideAfterInit = true) => {
    const location = useLocation();
    const isFirstRender = useIsFirstRender()
    const initialParams = useRef({});

    if (isFirstRender) {
        const result = {};
        const params = new URLSearchParams(location.search);
        searchParamsList.forEach(param => {
            result[_.camelCase(param)] = params.get(param);
        })
        initialParams.current = result;
    }

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        let isReplaceHistory = false;
        if (hideAfterInit) {
            searchParamsList.forEach(param => {
                if (queryParams.has(param)) {
                    queryParams.delete(param);
                    isReplaceHistory = true;
                }
            })
        }

        if (isReplaceHistory) {
            appHistory.replace({
                search: queryParams.toString(),
            })
        }
    }, [hideAfterInit, location.search, searchParamsList]);

    return initialParams.current;
}
